import * as React from "react";
import { Button, Form, FormInstance, Tag, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import { TShapeForm } from "src/components/TShapeForm/TShapeForm";
import { SizeType } from "antd/lib/config-provider/SizeContext";
import { DeleteOutlined, FilePdfOutlined } from "@ant-design/icons";
import { t } from "i18next";
import { confirmDelete } from "src/components/ModalDelete";
import { ZUid } from "src/types/zUid";
import { apiTechpack } from "src/common/apiUrl";
import { EntityAnchor } from "./EntityAnchor";
import { ZEntityAvailableState } from "../EntityPage.types";
import { EdCardValues } from "../apiEntityCard";
import { EntityCardStore, entityCardFormName } from "../EntityCardStore";
import { EntityStates } from "./EntityStates";
import styles from "./EntityFormWithAnchor2.module.less";

interface PropsEntityFormWithAnchor2 {
  title: React.ReactNode;
  store: EntityCardStore;
  submitText: string;
  onSubmit(values: EdCardValues): Promise<EdCardValues>;
  onSuccess(values: EdCardValues): void;
  disabled: boolean;
  availableStates: ZEntityAvailableState[] | undefined;
  onChangeState?(stateId: ZUid, form: FormInstance): Promise<void>;
  onDelete?(): Promise<void>;
}

const idEntityFormContainer = "EntityFormContainer";

export const EntityFormWithAnchor2: React.FC<PropsEntityFormWithAnchor2> =
  observer((props) => {
    const {
      title,
      submitText,
      store,
      onSubmit,
      onSuccess,
      disabled,
      onDelete,
      onChangeState,
    } = props;
    const {
      rootBlock,
      formStore,
      anchors,
      curStateName,
      stateOptions,
      attrNamesMap,
    } = store;
    const [form] = Form.useForm();
    const buttonsSize: SizeType = "middle";

    if (!rootBlock) return null;

    /*
     * Костыль с кнопкой экспорта ПДФ сделан в рамках задачи LPLM-4795
     * так как штатного решения не было, а показывать надо было срочно.
     */
    const extraButtons: React.ReactNode = (
      <>
        {store.objectId === "367b0a62-4dac-4928-9e7c-950dad613a8c" && (
          <Tooltip title="Экспорт карточки (.pdf)">
            <Button
              icon={<FilePdfOutlined />}
              href={apiTechpack(`/tender/${store.curEntityId}/report`)}
              target="_blank"
            />
          </Tooltip>
        )}
        {!!onDelete && !disabled && (
          <Button
            id="deleteCurEntity"
            icon={<DeleteOutlined />}
            onClick={() =>
              confirmDelete(
                t("Do you want to delete the current entry?"),
                onDelete,
              )
            }
            danger
            size={buttonsSize}
          >
            {t("Delete")}
          </Button>
        )}
      </>
    );

    const curStateView = curStateName ? (
      <Tag color="gold">{curStateName}</Tag>
    ) : undefined;
    return (
      <TShapeForm
        title={title}
        extraTitle={curStateView}
        form={form}
        formProps={{
          name: entityCardFormName,
          initialData: store.initialData,
          block: rootBlock,
          store: formStore,
          submit: onSubmit,
          submitText,
          onSuccess,
          disabled,
          buttonsSize,
          extraButtons,
          onValuesChange(changedValues, values) {
            store.onFormValuesChange(form, changedValues, values);
          },
        }}
        leftPart={
          <>
            <EntityAnchor
              anchors={anchors}
              containerSelector={`#${idEntityFormContainer}`}
            />
            {curStateView && (
              <EntityStates
                currentState={curStateView}
                stateOptions={Array.from(stateOptions.values())}
                attrNamesMap={attrNamesMap}
                onFinish={async (stateId) => {
                  onChangeState?.(stateId, form);
                }}
              />
            )}
          </>
        }
        leftPartClass={styles.leftPartCustom}
        rightPartProps={{ id: idEntityFormContainer }}
      />
    );
  });
